import {CanActivateFn, UrlTree} from '@angular/router';
import {inject} from '@angular/core';
import {OKTA_AUTH} from '@okta/okta-angular';


export const customOktaAuthGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const oktaAuth = inject(OKTA_AUTH);
    const isOnline = navigator.onLine

    if (isOnline) {
        const isAuthenticated =  await oktaAuth.isAuthenticated();
        if(!isAuthenticated) {
            await oktaAuth.signInWithRedirect();
        }
    }
    return true;
};